export const LISTING_MEDIA_TABS = ['gallery', 'floorplan', 'map', 'epc', 'brochure'];
export const DEFAULT_LISTING_MEDIA_TABS = [...LISTING_MEDIA_TABS];
export function isListingMediaTab(value) {
    return typeof value === 'string' && LISTING_MEDIA_TABS.includes(value);
}
export function normalizeListingMediaTabs(value) {
    if (!Array.isArray(value)) {
        return DEFAULT_LISTING_MEDIA_TABS;
    }
    const uniqueTabs = [];
    const seen = new Set();
    value.forEach((item) => {
        if (!isListingMediaTab(item) || seen.has(item)) {
            return;
        }
        seen.add(item);
        uniqueTabs.push(item);
    });
    return uniqueTabs;
}
